module.exports = __webpack_public_path__ + "img/bank-card.fe76d8b0.png";